// Canonical IBJJF belt registry — mirrors backend `Belt` literal in models.py.
// Kids belts use CSS gradient classes (defined in index.css) for the striped variants.

// Full progression order (kids → adult)
export const BELT_ORDER = [
  "white",
  "gray-white", "gray", "gray-black",
  "yellow-white", "yellow", "yellow-black",
  "orange-white", "orange", "orange-black",
  "green-white", "green", "green-black",
  "blue", "purple", "brown", "black",
];

// Adult track (age 16+)
export const ADULT_BELTS = ["white", "blue", "purple", "brown", "black"];

// Kids track (per IBJJF; ages 4–15)
export const KIDS_BELTS = [
  "white",
  "gray-white", "gray", "gray-black",
  "yellow-white", "yellow", "yellow-black",
  "orange-white", "orange", "orange-black",
  "green-white", "green", "green-black",
];

// CSS class for the belt-bar chip (all defined in /app/frontend/src/index.css).
export const BELT_CLASS = Object.fromEntries(BELT_ORDER.map(b => [b, `belt-${b}`]));

// Solid base color per belt (for the round dot / bar background when a CSS
// gradient class isn't being used). Striped kids belts use their dominant color.
export const BELT_COLOR = {
  white: "#f0eee9",
  "gray-white": "#9aa1a8", gray: "#9aa1a8", "gray-black": "#9aa1a8",
  "yellow-white": "#ffd63a", yellow: "#ffd63a", "yellow-black": "#ffd63a",
  "orange-white": "#ff8f3a", orange: "#ff8f3a", "orange-black": "#ff8f3a",
  "green-white": "#4dbf6c", green: "#4dbf6c", "green-black": "#4dbf6c",
  blue: "#4f8eff", purple: "#b266ff", brown: "#c97a3b", black: "#1a1a1a",
};

// Is this belt part of the kids track (not the adult 5-belt system)?
export const isKidsBelt = (b) => KIDS_BELTS.includes(b) && b !== "white";

// Pretty label for UI (Title Case with the dash preserved).
export const beltLabel = (b) =>
  (b || "").split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join("-");
